import React, { useState, useEffect, useRef, useMemo } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import BasicCrudService from "../../service/BasicCrudService";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Dropdown } from "primereact/dropdown";

const ProductList = () => {
  const resourcePlural = "products";

  const emptyEntity = {
    name: "",
    description: "",
    parent: "",
  };

  const [entity, setEntity] = useState(emptyEntity);
  const [entities, setEntities] = useState([]);
  const [entityDialog, setEntityDialog] = useState(false);
  const [deleteEntityDialog, setDeleteEntityDialog] = useState(false);
  const [deleteEntitiesDialog, setDeleteEntitiesDialog] = useState(false);
  const [selectedEntities, setSelectedEntities] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);
  const requiredText = "Ce champ est obligatoire";

  const crudService = useMemo(() => {
    return new BasicCrudService();
  }, []);

  const productsToBeSelected =
    entities.length !== 0
      ? entities.map((entity) => {
          return {
            label: entity.attributes.name,
            value: entity.id,
          };
        })
      : [];

  function getProductById(id, products) {
    return products.find((product) => product.id === id);
  }

  useEffect(() => {
    crudService.get(`${resourcePlural}`).then((data) => {
      setEntities(data.data);
    });
  }, [crudService]);

  function clearEmptyFields(fields) {
    Object.keys(fields).forEach((key) => {
      if (!fields[key]) {
        delete fields[key];
      }
    });
    return fields;
  }

  const formik = useFormik({
    initialValues: entity,
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string().required(),
      description: Yup.string().required(),
    }),
    onSubmit: (values) => {
      values = clearEmptyFields(values);
      saveEntity(values, () => {
        formik.resetForm();
      });
    },
  });

  const openNew = () => {
    setEntity(emptyEntity);
    setEntityDialog(true);
  };

  const hideDialog = () => {
    setEntityDialog(false);
    formik.resetForm();
  };

  const hideDeleteEntityDialog = () => {
    setDeleteEntityDialog(false);
  };

  const hideDeletecountriesDialog = () => {
    setDeleteEntitiesDialog(false);
  };

  const saveEntity = (values, onSuccess) => {
    let _entities = [...entities];
    let _entity = { ...values };

    if (entity.id) {
      const index = findIndexById(entity.id);

      crudService
        .update(resourcePlural, entity.id, _entity)
        .then((result) => {
          const product = result.data;

          if (_entity.parent) {
            const parentId = _entity.parent;
            const parent = getProductById(parentId, entities);
            product.attributes.parent = {
              data: parent,
            };
          }

          _entities[index] = product;
          setEntities(_entities);
          setEntityDialog(false);
          setEntity(emptyEntity);
          onSuccess();
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail: "Element mis à jour",
            life: 3000,
          });
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Le formulaire contient des erreurs",
            life: 3000,
          });
        });
    } else {
      crudService
        .save(resourcePlural, _entity)
        .then((result) => {
          const product = result.data;

          if (_entity.parent) {
            const parentId = _entity.parent;
            const parent = getProductById(parentId, entities);
            product.attributes.parent = {
              data: parent,
            };
          }

          _entities.unshift(product);
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail: "Element enregistré",
            life: 3000,
          });
          setEntities(_entities);
          setEntityDialog(false);
          setEntity(emptyEntity);
          onSuccess();
        })
        .catch((err) => {
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Le formulaire contient des erreurs",
            life: 3000,
          });
        });
    }
  };

  const editEntitiy = (entitySelected) => {
    const entity = {
      id: entitySelected.id,
      name: entitySelected.attributes.name,
      description: entitySelected.attributes.description,
      parent: "",
    };
    if (
      entitySelected.attributes.parent &&
      entitySelected.attributes.parent.data
    ) {
      entity.parent = entitySelected.attributes.parent.data.id;
    }
    setEntity(entity);
    setEntityDialog(true);
  };

  const confirmDeleteEntitiy = (entity) => {
    setEntity(entity);
    setDeleteEntityDialog(true);
  };

  const deleteEntitiy = () => {
    crudService
      .delete(resourcePlural, entity.id)
      .then((data) => {
        let _entities = entities.filter((val) => val.id !== entity.id);
        setEntities(_entities);
        setDeleteEntityDialog(false);
        setEntity(emptyEntity);
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: "Element supprimée",
          life: 3000,
        });
      })
      .catch((err) => {
        setEntity(emptyEntity);
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Impossible de supprimer la Element",
          life: 3000,
        });
      });
  };

  const findIndexById = (id) => {
    return entities.findIndex((item) => item.id === id);
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteEntitiesDialog(true);
  };

  const deleteselectedEntities = () => {
    let _entities = entities.filter((val) => !selectedEntities.includes(val));
    setEntities(_entities);
    setDeleteEntitiesDialog(false);
    setSelectedEntities(null);
    toast.current.show({
      severity: "success",
      summary: "Succès",
      detail: " supprimés",
      life: 3000,
    });
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button
            label="Ajouter"
            icon="pi pi-plus"
            className="p-button-success mr-2"
            onClick={openNew}
          />
          <Button
            label="Supprimer"
            icon="pi pi-trash"
            className="p-button-danger"
            onClick={confirmDeleteSelected}
            disabled={!selectedEntities || !selectedEntities.length}
          />
        </div>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Exporter"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
      </React.Fragment>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions">
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success mr-2"
          onClick={() => editEntitiy(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-warning mt-2"
          onClick={() => confirmDeleteEntitiy(rowData)}
        />
      </div>
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Gestion des produits</h5>
      <span className="block mt-2 md:mt-0 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );

  const userDialogFooter = (
    <>
      <Button
        label="Annuler"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Valider"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => formik.submitForm()}
      />
    </>
  );
  const deleteEntitiyDialogFooter = (
    <>
      <Button
        label="Non"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteEntityDialog}
      />
      <Button
        label="Oui"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteEntitiy}
      />
    </>
  );
  const deleteEntitiesDialogFooter = (
    <>
      <Button
        label="Non"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeletecountriesDialog}
      />
      <Button
        label="Oui"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteselectedEntities}
      />
    </>
  );

  return (
    <div className="grid crud-demo">
      <div className="col-12">
        <div className="card">
          <Toast ref={toast} />
          <Toolbar
            className="mb-4"
            left={leftToolbarTemplate}
            right={rightToolbarTemplate}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={entities}
            selection={selectedEntities}
            onSelectionChange={(e) => setSelectedEntities(e.value)}
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            className="datatable-responsive"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Affichage {first} à {last} de {totalRecords} éléments"
            globalFilter={globalFilter}
            emptyMessage="Aucune donnée trouvée"
            header={header}
            responsiveLayout="scroll"
          >
            <Column selectionMode="multiple"></Column>
            <Column
              field="name"
              body={(data) => data.attributes.name}
              header="Libellé"
              sortable
            ></Column>
            <Column
              field="category"
              body={(data) => {
                if (
                  data &&
                  data.attributes &&
                  data.attributes.parent &&
                  data.attributes.parent.data
                ) {
                  return data.attributes.parent.data.attributes.name;
                } else return "";
              }}
              header="Dérivé de"
              sortable
            ></Column>
            <Column body={actionBodyTemplate}></Column>
          </DataTable>

          <Dialog
            visible={entityDialog}
            style={{ width: "450px" }}
            header="Détails Element"
            modal
            className="p-fluid"
            footer={userDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="name">Libellé</label>
              <InputText
                id="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                required
                rows={3}
                cols={20}
                className={classNames({
                  "p-invalid": formik.errors.name && formik.touched.name,
                })}
              />
              {formik.errors.name && formik.touched.name && (
                <small className="p-error">{requiredText}</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="category">Description</label>
              <InputText
                id="description"
                value={formik.values.description}
                onChange={formik.handleChange}
                required
                rows={10}
                cols={20}
                className={classNames({
                  "p-invalid":
                    formik.errors.description && formik.touched.description,
                })}
              />
              {formik.errors.description && formik.touched.description && (
                <small className="p-error">{requiredText}</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="category">Produit dérivé de</label>
              <Dropdown
                value={formik.values.parent}
                options={productsToBeSelected}
                className={classNames({
                  "p-invalid": formik.errors.parent && formik.touched.parent,
                })}
                onChange={(e) => {
                  formik.setFieldValue("parent", e.value);
                }}
                placeholder="Sélectionner une catégorie"
              />
              {formik.errors.parent && formik.touched.parent && (
                <small className="p-error">{requiredText}</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={deleteEntityDialog}
            style={{ width: "450px" }}
            header="Confirm"
            modal
            footer={deleteEntitiyDialogFooter}
            onHide={hideDeleteEntityDialog}
          >
            <div className="flex align-items-center justify-content-center">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{ fontSize: "2rem" }}
              />
              {entity && (
                <span>
                  Voulez vous vraiment supprimer <b>{entity.username}</b>?
                </span>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={deleteEntitiesDialog}
            style={{ width: "450px" }}
            header="Confirm"
            modal
            footer={deleteEntitiesDialogFooter}
            onHide={hideDeletecountriesDialog}
          >
            <div className="flex align-items-center justify-content-center">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{ fontSize: "2rem" }}
              />
              {entity && (
                <span>
                  Voulez vous vraiment supprimer les Elements sélectionnées?
                </span>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
